import script from "./GameTab.vue?vue&type=script&setup=true&lang=js"
export * from "./GameTab.vue?vue&type=script&setup=true&lang=js"

import "./GameTab.vue?vue&type=style&index=0&id=0f2e6170&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0f2e6170"]])

export default __exports__